<template>
    <div>
        <div :style="{bottom:displayInputBottom}">
            <input class="message-input" v-model="text" :disabled="!isTimReady" :placeholder="isTimReady?'Chat with the host':'Initializing, please wait'" placeholder-style="color:#fff;font-size:0.6rem" type="text" @keyup.enter="confirm"
         />
          <div class="confirms" @click="confirm">Submit</div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    isTimReady: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      text: '',
      displayInputBottom: '0px'
    }
  },
  methods: {
    confirm () {
      this.$emit('send-message', this.text)
      this.text = ''
    }
  },
  computed: {}
}
</script>
<style type="scss" scoped>
.confirms{display: inline-block;float: right;width: 29%;font-size: 12px;color: #fff;background: #FF0000;line-height: 1.35rem;border-radius:1.35rem ;text-align: center;}
    .message-input {
        height: 1.35rem;
        width: 70%;
        box-sizing: border-box;
        border-radius: 0.84375rem;
        border-radius: 0.84375rem;
        padding-left: 0.421875rem;
        padding-right: 0.421875rem;
        line-height: 1.35rem;
        border: 0;
        outline: none;
        font-size: 0.6rem;
        color: #fff;
        background: none;
    }
</style>
